import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { AiImageGenCanvas } from '@/features/app-shell/canvases/ai-image-gen-canvas'

export const Route = createFileRoute('/app/tools/image-gen')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppToolsImageGenPage,
})

function AppToolsImageGenPage() {
  return (
    <AppShell activePath="/app">
      <AiImageGenCanvas />
    </AppShell>
  )
}
